import React, { useState } from 'react';
import { Mail, ArrowRight, Users } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const MailingList = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    // Mock API call - will be replaced with real backend integration
    setTimeout(() => {
      console.log('Email submitted:', email);
      toast({
        title: "Welcome to the movement! 🔥",
        description: "Stay brown. Stay bold. #Brownishh",
      });
      setEmail('');
      setIsLoading(false);
    }, 1000);
  };

  return (
    <section id="mailing-list" className="py-20 bg-gradient-to-r from-warmBrown to-deepBrown">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Users className="w-6 h-6 text-goldAccent" />
            <span className="text-goldAccent font-bold text-sm tracking-widest uppercase">Join the Movement</span>
          </div>
          
          <h2 className="text-4xl sm:text-5xl font-black text-warmCream mb-6 tracking-tight">
            Be the first to know.
            <br />
            <span className="text-goldAccent">Be the first to rep it.</span>
          </h2>
          
          <p className="text-xl text-warmCream/90 max-w-2xl mx-auto leading-relaxed">
            Get early access to drops, podcast episodes, and content made for the culture.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="max-w-md mx-auto mb-8">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-warmBrown" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full pl-10 pr-4 py-4 bg-warmCream text-richBrown placeholder-warmBrown/60 rounded-none border-2 border-transparent focus:border-goldAccent focus:outline-none font-medium"
                required
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="group bg-goldAccent hover:bg-goldAccent/90 text-richBrown font-bold py-4 px-8 rounded-none transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 text-lg tracking-wide min-w-[200px] disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <div className="w-5 h-5 border-2 border-richBrown/30 border-t-richBrown rounded-full animate-spin"></div>
              ) : (
                <>
                  JOIN THE MOVEMENT
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                </>
              )}
            </button>
          </div>
        </form>

        {/* Brand Promise */}
        <div className="text-center">
          <p className="text-xl font-bold text-goldAccent mb-2">
            Stay brown. Stay bold. #Brownishh
          </p>
          <div className="flex items-center justify-center gap-6 text-warmCream/70 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
              <span>First access to drops</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
              <span>Exclusive content</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-goldAccent rounded-full"></div>
              <span>Cultural movement updates</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MailingList;